// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boardPopText{z-index:999;top:20%;position:absolute;background-color:#fff;overflow:hidden;margin:10px;border-radius:10px;padding:15px;min-height:400px;max-height:70%}.boardPopAlimImg{width:100px;right:20px;position:absolute;float:right;bottom:calc(30% - 100px)}", ""]);
// Exports
module.exports = exports;
